<template>
  <div class="header">
    <div class="content">
      <div class="logo" @click="openLink(3)">
        <img :src="logoObj.logo" alt="logo" v-if="logoObj.type === 1">
        <h1 v-else>{{logoObj.logo}}</h1>
      </div>
      <div class="right">
        <div class="user" v-if="loginStatus.status">
          <span>欢迎您！{{loginStatus.userName}}</span>
          <i></i>
          <label @click="loginOut">退出</label>
        </div>
        <div class="user" v-else>
          <label @click="openLink(1)">登录</label>
          <i></i>
          <label @click="openLink(2)">注册</label>
        </div>
        <div class="phone" v-if="phone">
          <img src="https://img2.233.com/wx/union/pure/pc/blue/tp_tel.png" v-if="skinColor === 'blue'">
          <img src="https://img2.233.com/wx/union/pure/pc/green/tp_tel.png" v-else-if="skinColor === 'green'">
          <img src="https://img2.233.com/wx/union/pure/pc/red/tp_tel.png" v-else>
          <span>{{phone}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    phone: {
      type: String,
      default: ""
    },
    logoObj: {
      type: Object,
      default: () => {}
    },
    loginStatus: {
      type: Object,
      default: () => {}
    },
    skinColor: {
      type: String,
      default: ""
    },
    seniorFlog: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    loginOut() {
      localStorage.removeItem("usertoken")
      window.location.reload()
    },
    openLink(type) {
      switch (type) {
        case 1:
          window.location.href = window.location.origin + "/uc/login?redirecturl=" + window.location.href
          break;
        case 2:
          window.open(window.location.origin + "/uc/register")
          break;
        case 3:
          window.open(window.location.origin + (this.seniorFlog ? "/fine" : "/norm"))
          break;
        default:
          break;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/index.scss";
.header{
  line-height: 75px;
  border-bottom: 1px solid #E0E0E0;
  background: white;
  .content{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo{
      height: 46px;
      line-height: 46px;
      cursor: pointer;
      img{
        height: 46px;
        vertical-align: top;
      }
    }
    .right{
      display: flex;
      align-items: center;
      .user{
        display: flex;
        align-items: center;
        span{
          color: #888;
          font-size: 15px;
          font-weight: 400;
        }
        i{
          display: inline-block;
          width: 1px;
          height: 16px;
          background: #CDCDCD;
          margin: 0 13px;
        }
        label{
          color: #565656;
          font-size: 15px;
          font-weight: 400;
          cursor: pointer;
          &:hover{
            @include globe_hover_color();
          }
        }
      }
      .phone{
        display: flex;
        align-items: center;
        img{
          margin: 0 3px 0 42px;
          width: 18px;
          height: 19px;
        }
        span{
          @include header_color();
          font-size: 21px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>